function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// src/virtual-agent/context.tsx
import React3, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { openChatWidget, setVacFrameVisibilityHidden } from "@shared-ui/customer-virtual-agent-control";
import { useExperiment } from "@shared-ui/experiment-context";

// ../internal/src/utils/virtual-agent-helper/virtual-agent-control-helpers.ts
var sendMessage = async (data, logEvents) => {
  var _a, _b;
  if (((_a = window == null ? void 0 : window.VirtualAgentControl) == null ? void 0 : _a.initialized) && (window == null ? void 0 : window.VacClientAdapter)) {
    const isInit = await window.VirtualAgentControl.initialized;
    if (isInit) {
      const chatInstance = await window.VacClientAdapter.getInstance();
      if (await chatInstance.isInitialized) {
        logEvents == null ? void 0 : logEvents.SENDING_MESSAGE.log({
          message: `Sending message - ${data.text}`
        });
        (_b = chatInstance == null ? void 0 : chatInstance.vacFrame) == null ? void 0 : _b.sendMessage(data);
        return;
      }
    }
  }
  logEvents == null ? void 0 : logEvents.VAC_NOT_INITIALISED.log({
    message: `VAC is not initialised when trying to send message - ${data.text}`
  });
};

// src/contact-us-widget/state-provider/contact-us-state-provider.tsx
import React from "react";
import { buildStateProvider } from "@shared-ui/provided-state-context";

// src/contact-us-widget/state-provider/contact-us-view-state/constants.ts
var ContactUsStateEvent = /* @__PURE__ */(ContactUsStateEvent2 => {
  ContactUsStateEvent2["OPEN_WIDGET"] = "OPEN_WIDGET";
  ContactUsStateEvent2["CLOSE_WIDGET"] = "CLOSE_WIDGET";
  ContactUsStateEvent2["CHANGE_VIEW"] = "CHANGE_VIEW";
  ContactUsStateEvent2["REDIRECT_RETURN"] = "REDIRECT_RETURN";
  ContactUsStateEvent2["UPDATE_PAYLOAD"] = "UPDATE_PAYLOAD";
  return ContactUsStateEvent2;
})(ContactUsStateEvent || {});
var ContactUsViewType = /* @__PURE__ */(ContactUsViewType2 => {
  ContactUsViewType2["CHAT_OPTIONS"] = "CHAT_OPTIONS";
  ContactUsViewType2["CONTACT_OPTIONS"] = "CONTACT_OPTIONS";
  ContactUsViewType2["LANDING_PAGE"] = "LANDING_PAGE";
  ContactUsViewType2["VIRTUAL_AGENT"] = "VIRTUAL_AGENT";
  ContactUsViewType2["VOICE_OPTIONS"] = "VOICE_OPTIONS";
  ContactUsViewType2["BLANK_PAGE"] = "BLANK_PAGE";
  return ContactUsViewType2;
})(ContactUsViewType || {});

// src/contact-us-widget/state-provider/contact-us-view-state/contact-us-state.ts
var ContactUsState = /*#__PURE__*/function () {
  function ContactUsState() {
    _classCallCheck(this, ContactUsState);
    this.stateFieldName = "contactUsState";
    this.data = {
      view: "LANDING_PAGE" /* LANDING_PAGE */,
      shouldWidgetBeVisible: false
    };
    this.events = Object.values(ContactUsStateEvent);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return _createClass(ContactUsState, [{
    key: "update",
    value: function update(event, currentState, payload) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
      switch (event) {
        case "OPEN_WIDGET" /* OPEN_WIDGET */:
          return {
            view: payload.data.view,
            shouldWidgetBeVisible: true,
            intent: (_a = payload.data.intent) != null ? _a : "",
            product: (_b = payload.data.product) != null ? _b : ""
          };
        case "CLOSE_WIDGET" /* CLOSE_WIDGET */:
          return {
            view: (payload == null ? void 0 : payload.data.view) || currentState.view,
            shouldWidgetBeVisible: false,
            intent: (_c = payload.data.intent) != null ? _c : "",
            product: (_d = payload.data.product) != null ? _d : ""
          };
        case "CHANGE_VIEW" /* CHANGE_VIEW */:
          return {
            view: payload.data.view,
            shouldWidgetBeVisible: true,
            intent: (_e = payload.data.intent) != null ? _e : "",
            product: (_f = payload.data.product) != null ? _f : ""
          };
        case "REDIRECT_RETURN" /* REDIRECT_RETURN */:
          localStorage.setItem("contactUsView", currentState.view);
          return {
            view: currentState.view,
            shouldWidgetBeVisible: currentState.shouldWidgetBeVisible,
            intent: (_g = payload.data.intent) != null ? _g : "",
            product: (_h = payload.data.product) != null ? _h : ""
          };
        case "UPDATE_PAYLOAD" /* UPDATE_PAYLOAD */:
          return {
            view: payload.data.view,
            shouldWidgetBeVisible: true,
            intent: (_i = payload.data.intent) != null ? _i : currentState.intent,
            product: (_j = payload.data.product) != null ? _j : currentState.product
          };
        default:
          return currentState;
      }
    }
  }]);
}();

// src/contact-us-widget/state-provider/contact-us-state-provider.tsx
var ContactUsStateProvider = buildStateProvider(new ContactUsState());
var withContactUsStateProvider = WrappedComponent => {
  const Wrapper = props => {
    return /* @__PURE__ */React.createElement(ContactUsStateProvider, null, /* @__PURE__ */React.createElement(WrappedComponent, {
      ...props
    }));
  };
  Wrapper.displayName = "withContactUsStateProvider";
  return Wrapper;
};

// src/contact-us-widget/hooks/use-contact-us-state.tsx
import React2 from "react";
import { useProvidedState } from "@shared-ui/provided-state-context";
function useContactUsState() {
  const [state, dispatch] = useProvidedState();
  const {
    contactUsState
  } = state;
  const contactUsStateDispatch = React2.useCallback(({
    type,
    payload
  }) => {
    const contactUsStateAction = {
      type,
      payload: {
        ...payload
      }
    };
    dispatch(contactUsStateAction);
  }, [dispatch]);
  return [contactUsState, contactUsStateDispatch];
}

// src/virtual-agent/config.ts
var REQUIRED_EVENT = ["VAC_ConversationCreated" /* CONVERSATION_CREATED_EVENT */];

// src/virtual-agent/context.tsx
var defaultContextValue = {
  config: {
    eventHandler: () => console.error("Help Center VA Context Util not yet initialized")
  },
  controller: {
    sendMessage: () => console.error("Help Center VA Context Util not yet initialized")
  }
};
var VirtualAgentContext = createContext(defaultContextValue);
var VirtualAgentContextProvider = ({
  children
}) => {
  const [vaEvent, setVaEvent] = useState();
  const [conversationCreated, setConversationCreated] = useState(false);
  const [message, setMessage] = useState();
  const [, contactUsStateDispatch] = useContactUsState();
  const isNewContactUsExperience = useExperiment("Contact_Us_Redesign_MVP_BEX_HCOM").exposure.bucket === 1;
  const sendMessage2 = useCallback(input => {
    if (!isNewContactUsExperience) {
      openChatWidget();
      setVacFrameVisibilityHidden(false);
    } else {
      contactUsStateDispatch({
        type: "OPEN_WIDGET" /* OPEN_WIDGET */,
        payload: {
          view: "VIRTUAL_AGENT" /* VIRTUAL_AGENT */
        }
      });
    }
    if (conversationCreated) {
      sendMessage(input);
      setMessage(void 0);
    } else {
      setMessage(input);
    }
  }, [conversationCreated, setMessage]);
  useEffect(() => {
    if (message) {
      sendMessage(message);
    }
  }, [conversationCreated]);
  useEffect(() => {
    if (!vaEvent) {
      return;
    }
    switch (vaEvent.type) {
      case "VAC_ConversationCreated" /* CONVERSATION_CREATED_EVENT */:
        setConversationCreated(true);
        break;
    }
  }, [vaEvent]);
  const vaContextValue = useMemo(() => ({
    config: {
      eventHandler: setVaEvent
    },
    controller: {
      sendMessage: sendMessage2
    }
  }), [sendMessage2, setVaEvent]);
  return /* @__PURE__ */React3.createElement(VirtualAgentContext.Provider, {
    value: vaContextValue
  }, children);
};
var useVirtualAgentContext = () => useContext(VirtualAgentContext);

// src/virtual-agent/mock-context.tsx
import React4, { useMemo as useMemo2 } from "react";
var MockVirtualAgentContextProvider = ({
  mockController,
  mockConfig,
  children
}) => {
  const vaContextValue = useMemo2(() => ({
    config: {
      eventHandler: (mockConfig == null ? void 0 : mockConfig.eventHandler) || (() => console.warn("config.eventHandler not set"))
    },
    controller: {
      sendMessage: (mockController == null ? void 0 : mockController.sendMessage) || (() => console.warn("controller.sendMessage not set"))
    }
  }), [mockController]);
  return /* @__PURE__ */React4.createElement(VirtualAgentContext.Provider, {
    value: vaContextValue
  }, children);
};
export { ContactUsState, ContactUsStateEvent, ContactUsStateProvider, ContactUsViewType, MockVirtualAgentContextProvider, REQUIRED_EVENT, VirtualAgentContextProvider, useContactUsState, useVirtualAgentContext, withContactUsStateProvider };
/* istanbul ignore file -- @preserve */
//# sourceMappingURL=index.js.map